import React from 'react'
import styles from './style.module.css'
const Index = () => {
    const searchItems = [
        {
            date: 'Oct 18, 2024',
            title: 'Next Js Developer with Node and Mongo DB Expertise and Can lead the team.',
        },
        {
            date: 'Oct 18, 2024',
            title: 'Next Js Developer with Node and Mongo DB Expertise and Can lead the team.',
        },
        {
            date: 'Oct 18, 2024',
            title: 'Next Js Developer with Node and Mongo DB Expertise and Can lead the team.',
        },
        {
            date: 'Oct 18, 2024',
            title: 'Next Js Developer with Node and Mongo DB Expertise and Can lead the team.',
        },
    ];
    return (
        <React.Fragment>
            <div className={`${styles['card-credits']} p-3 mb-3 shadow-sm`}>
                <div className="card-header bg-white d-flex justify-content-between align-items-center">
                    <h5 className={`${styles['credits-title']}`}>Search History</h5>
                    <a href="#see-all" className={`${styles['see-all']}`}>
                        See All
                    </a>
                </div>
                <hr className='mt-0' />
                <div className={`${styles['main-box']} list-group list-group-flush`}>
                    {searchItems.map((item, index) => (
                        <div key={index} className={`${styles['job-card']}`}>
                            <div className={`${styles['date-badge']}`}>{item.date}</div>
                            <div className={`${styles['job-info']}`}>
                                <span>{item.title}</span>
                                <div className={`${styles['link-badge']}`}>
                                    <a href='#' className={`${styles['fill-badge']}`}>Fill search</a>
                                    <a href='#' className={`${styles['search-badge']}`}>Search Candidate</a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </React.Fragment>
    )
}

export default Index